export default __webpack_public_path__ + "static/media/025-party blower.4af8a266.svg";